const protectRoutes = (routes, flags) => routes.map((route) => ({
  ...route,
  meta: {
    ...(route.meta || {}),
    ...flags,
  },
}));

export default protectRoutes;
